$( document ).ready(function() {
  var name = $('.product-variants--radio .product-variant__item input:checked+label').attr('attr');
   $('body.product span.opt_name').text(':- '+name);
    var price = parseFloat($('.price_code .orig_price').attr('price_main')) || 0; 
    $('.main_data_coll').attr('priceupdate',price);
    $(".custom-products").each(function() {
        var title = $(this).attr('data_coll');
        if (name === title) {
            $(this).show();
            $(this).addClass('selected_items_custom');
        } else {
            $(this).hide();
            $(this).removeClass('selected_items_custom');
        }
    });
    $('.selected_tm').removeClass('selected_tm');
    var selectedItems = $('.selected_items_custom');
    if (selectedItems.length > 0) {
        //selectedItems.first().toggleClass('selected_tm');
    }
        var selectedTmElement = $('.selected_tm');
        var price2 = parseFloat(selectedTmElement.attr('varprice')) || 0; 
           setTimeout(function() {
         var id = $('.selected_tm').attr('varid');
          $('.second_var').val(id);
        var totalPrice = price + price2;
        var formattedCheck = (totalPrice / 100).toFixed(2);
          var formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'AED',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
    var formattedCurrency = formatter.format(formattedCheck);
    formattedCurrency = formattedCurrency.replace('AED', 'Dhs.');
    var displayText = `${formattedCurrency}`;
    $('body.product .price_code .orig_price').text(displayText);
            }, 1000);
});


$('.custom-products').click(function() {
    $(this).toggleClass('selected_tm');
    $(this).siblings().removeClass('selected_tm');
    var id = $(this).attr('varid');
    if ($(this).hasClass("selected_tm")) {
    $('.second_var').val(id);
    var price = parseFloat($('.main_data_coll').attr('priceupdate')) || 0;
    var price2 = parseFloat($(this).attr('varprice')) || 0;
    var totalPrice = price + price2;
    console.log(price);
    console.log(price2);
    var formattedCheck = (totalPrice / 100).toFixed(2);
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'AED',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
      var formattedCurrency = formatter.format(formattedCheck);
      formattedCurrency = formattedCurrency.replace('AED', 'Dhs.');
      var displayText = `${formattedCurrency}`;
     $('body.product .price_code .orig_price').text(displayText);
      console.log('111');
      }else{
      console.log('222');
      $('.second_var').val('');
      var totalPrice = $('.main_data_coll').attr('priceupdate');
       var formattedCheck = (totalPrice / 100).toFixed(2);
        var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'AED',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
      var formattedCurrency = formatter.format(formattedCheck);
      formattedCurrency = formattedCurrency.replace('AED', 'Dhs.');
      var displayText = `${formattedCurrency}`;
      $('body.product .price_code .orig_price').text(displayText);
      }
});





document.querySelector('product-variants').addEventListener('change', function() {
    var variantElement = document.querySelector('product-variants');
    var name = variantElement.currentVariant.title;
     $('body.product span.opt_name').text(':- '+name);
    var price = parseFloat(variantElement.currentVariant.price) || 0; 
      $('.main_data_coll').attr('priceupdate',price);
    $(".custom-products").each(function() {
        var title = $(this).attr('data_coll');
        if (name === title) {
            $(this).show();
            $(this).addClass('selected_items_custom');
        } else {
            $(this).hide();
            $(this).removeClass('selected_items_custom');
        }
    });
    $('.selected_tm').removeClass('selected_tm');
    
    var selectedItems = $('.selected_items_custom');
    if (selectedItems.length > 0) {
        selectedItems.first().toggleClass('selected_tm');
    }
        var selectedTmElement = $('.selected_tm');
        var id = $(selectedTmElement).attr('varid');
         $('.second_var').val(id);
        var price2 = parseFloat(selectedTmElement.attr('varprice')) || 0; 
        var totalPrice = price + price2;
        var formattedCheck = (totalPrice / 100).toFixed(2);
            var formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'AED',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
          });
        var formattedCurrency = formatter.format(formattedCheck);
        formattedCurrency = formattedCurrency.replace('AED', 'Dhs.');
        var displayText = `${formattedCurrency}`;
        $('body.product .price_code .orig_price').text(displayText);
});



$('button.new_check_out').click(function(event) {
    event.preventDefault(); 
    var firstId = $('input.fisrt_var').val();
    var secondId = $('input.second_var').val();
    var quantity = $('body.product .product-quantity__selector').val();
    var items = [];
    if (firstId) {
        items.push({ id: firstId, quantity: quantity });
    }
    if (secondId) {
        items.push({ id: secondId, quantity: quantity });
    }
    if (items.length > 0) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: JSON.stringify({ items: items }),
            contentType: 'application/json',
            dataType: 'json',
            success: function() {
                window.location.href = '/checkout';
            },
            error: function(xhr) {
                console.error('Error adding product to cart:', xhr.responseText);
            }
        });
    } else {
        console.error('No valid product IDs provided.');
    }
});


